/*
 * This file is part of the Akershus Eiendom Nettsted 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';

/**
 * This is the Logo component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function Logo({ title }) {
  return (
    <span className="svg svg-logo">
      <span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88.1 82.9">
          <title>{title}</title>
          <path
            d="M48.3,0H39.7L0,75l4.2,7.9H83.7l4.4-7.8ZM40.7,1.6h5.9L24.5,43.4H63.7L48,13.9,33.2,41.8H27.1L47.9,2.5,86.3,75l-3,5.4L66.4,48.6H21.7L11.4,68H67.3l3.3,6.1H2.2ZM55.2,41.8l-10.1-19L48,17.2,61,41.7H55.2Zm-11-17.3,9.2,17.3H35ZM22.3,50.8l3.6,4.9L20.2,66.4H14Zm5,5.6H61.2l5.3,10H22Zm34-1.6H27.2l-3.4-4.7H64.5ZM2.2,75.7h71l-10.6-20,3.2-4.8L82,81.3H5.2Z"
            fill="#fff"
          />
        </svg>
      </span>
    </span>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Logo.propTypes = {
  title: PropTypes.string,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
Logo.defaultProps = {
  title: 'Logo',
};

export default Logo;
